<template>
	<div>
		<div class="p-2">
			<b-button @click="$router.go(-1)" variant="outline-dark">
				<i class="fa fa-chevron-left"></i> {{ $t('back') }}
			</b-button>
			<b-button style="position: absolute; right: 20px" v-if="$route.params.action !== 'view'" variant="success"
					  @click="saveRequestDoc($route.params.action)">{{ $t('save-finish') }}
			</b-button>
			<b-button style="position: absolute; right: 220px" v-if="$route.params.action === 'check'" variant="warning"
					  @click="toRecount">{{ $t('actions.recount') }}
			</b-button>
		</div>
		<b-card>
			<b-navbar class="bg-primary" toggleable="lg" type="dark">
				<b-navbar-brand>{{ $t('sidebar.warehouse-management.requests') }}</b-navbar-brand>
				<b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
				<b-navbar-nav>
					<!--					<b-nav-item>Link</b-nav-item>-->
					<!--					<b-nav-item>Disabled</b-nav-item>-->
				</b-navbar-nav>
				<!-- Right aligned nav items -->
				<b-navbar-nav class="ml-auto">
					<b-nav-form>
						<b-input-group size="sm">
							<b-input-group-append is-text><i class="fa fa-search"/></b-input-group-append>
							<b-form-input v-model="payload.value" accesskey="g" @input="getList" class="mr-sm-2" placeholder="Search"/>
						</b-input-group>
					</b-nav-form>
				</b-navbar-nav>
			</b-navbar>
			<b-table v-if="items.length > 0" :items="items" :fields="tableFields" hover bordered :busy="loading" show-empty>
				<template #table-busy>
					<div class="text-center text-primary my-2">
						<b-spinner class="align-middle mr-2"></b-spinner>
						<strong>Loading...</strong>
					</div>
				</template>
				<template slot="index" slot-scope="data">
					{{ paginate(data.index, payload.page, payload.limit) }}
				</template>
				<template slot="multiBarcode" slot-scope="data">
					<div v-for="barcode in data.item.multiBarcode">{{ barcode }}</div>
				</template>
				<template :slot="`${items[0].fromDep.department_name}`" slot-scope="data">
					<div class="text-center" v-if="$route.params.action == 'edit'">
						<span><b>{{ data.item.fromDep.remaining }}</b></span>
						<b-input :value="remaining(data.item)" disabled style="width: 100%" :ref="`leftCount-${data.item.itemId}-${data.item.fromDepPriceUzs}-${data.item.termOfItem}`"/>
					</div>
					<div class="text-center" v-else-if="$route.params.action == 'check'">
						<span><b>{{ data.item.fromDep.remaining }}</b></span> /
						<span>{{ remainingToCheck(data.item) }}</span>
					</div>
					<div class="text-center" v-else>
						<span><b>{{ data.item.fromDep.remaining }}</b></span>
					</div>
				</template>
				<template v-for="(field, index) in dynamicFields" :slot="`${field}`" slot-scope="data">
					<div class="text-center" v-if="$route.params.action == 'edit'">
						<b>{{ data.item.toDeps ? data.item.toDeps[index].remaining : 0 }}</b>
						<b-input
							:id="data.item.toDeps[index].itemId + 'id' + data.item.toDeps[index].departmentId"
							:min="0"
							type="number"
							:max="remaining(data.item)"
							:value="data.item.toDeps[index].count"
							:ref="`count-${data.item.itemId}-${data.item.fromDepPriceUzs}`"
							@blur="updateCount(data.item, data.item.toDeps[index], $event.target.valueAsNumber)"/>
					</div>
					<div class="text-center" v-else-if="$route.params.action == 'view'">
						<span v-if="data.item.toDeps[index].count">
							<span><b>{{ data.item.toDeps[index].remaining }}</b></span> /
							<span>{{ data.item.toDeps[index].count }}</span>
							<span v-if="data.item.toDeps[index].sendCount"> / {{ data.item.toDeps[index].sendCount }}</span>
						</span>
					</div>
					<div v-else :class="data.item.toDeps[index].sendCount ? data.item.toDeps[index].count > data.item.toDeps[index].sendCount ? `bg-danger` : data.item.toDeps[index].count < data.item.toDeps[index].sendCount ? `bg-primary` : `bg-success` : ``" style="text-align: center">
						<span v-if="data.item.toDeps[index].count">
							<span><b>{{ data.item.toDeps[index].remaining }}</b></span> /
							<span>{{ data.item.toDeps[index].count }}</span>
							<span v-if="data.item.toDeps[index].sendCount"> / {{ data.item.toDeps[index].sendCount }}</span>
						</span>
					</div>
				</template>
				<template slot="fromDepPriceUzs" slot-scope="data">
					<div class="text-center" v-if="$route.params.action == 'edit'">
						{{ data.item.fromDepPriceUzs }}
					</div>
					<div class="text-center" v-else>
						{{ data.item.priceUzs }}
					</div>
				</template>
			</b-table>
			<table v-else class="table table-bordered table-striped table-hover" :fields="tableFields">
				<tr>
					<th v-for="field in tableFields">{{ field.label }}</th>
				</tr>
				<tr>
					<td colspan="6" class="text-center">
						<h5 class="mt-2"><b>Информация не найдена !</b></h5>
					</td>
				</tr>
			</table>
			<nav>
				<b-pagination :total-rows="total" :per-page="payload.limit" v-model="payload.page" aria-controls="table"/>
			</nav>
		</b-card>
	</div>
</template>

<script>
import WhDocument from "@/services/wh-document.service";

export default {
	name: "create_or_update",
	data() {
		return {
			items: [],
			total: 0,
			allCount: 0,
			loading: false,
			payload: {
				page: 1,
				limit: 12,
				value: '',
				requestDocId: this.$route.params.id
			},
			dynamicFields: [],
			tableFields: [
				{key: 'index', label: '#', class: 'text-center'},
				{key: 'itemName', label: this.$t('incomes.create.product')},
				{key: 'barcode', label: this.$t('goods.special-barcode'), class: 'text-center'},
				{key: 'multiBarcode', label: this.$t('goods.barcode'), class: 'text-center'},
				{key: 'termOfItem', label: this.$t('kirim.expirationDate'), class: 'text-center'},
				{key: 'fromDepPriceUzs', label: this.$t('incomes.create.price'), class: 'text-center'}
			]
		}
	},
	computed: {},
	watch: {
		'payload.page': {
			handler(newVal) {
				this.getList()
			}
		},
	},
	methods: {
		getList() {
			this.loading = true
			WhDocument.getRequestTransferCreateList(this.payload).then(res => {
				this.items = res.data.items
				this.total = res.data.total
				if (this.items.length > 0) {
					let o = {class: 'text-center'}
					o.key = res.data.items[0].fromDep.department_name
					o.label = res.data.items[0].fromDep.department_name
					this.tableFields.push(o)
					this.dynamicFields = []
					res.data.items[0].toDeps.forEach(dep => {
						let t = {class: 'text-center'}
						t.key = dep.departmentName
						t.label = dep.departmentName
						this.dynamicFields.push(dep.departmentName)
						this.tableFields.push(t)
					})
				}
				this.loading = false
			}).catch(e => {
				this.$vs.notify({
					title: e.response.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				})
				this.loading = false
			})
		},
		updateCount(item, dep, value) {
			if (isNaN(value))
				value = 0;
			let remain = this.remain(item, dep);

			if (value > remain) {
				this.$set(document.getElementById(dep.itemId + 'id' + dep.departmentId).style, 'border', '1px solid red')
				this.$vs.notify({
					title: `Error: ${remain}dan kop son kirita olmaysiz`,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				})
			} else if (value < 0) {
				this.$set(document.getElementById(dep.itemId + 'id' + dep.departmentId).style, 'border', '1px solid red')
				this.$vs.notify({
					title: 'Error',
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				})
			} else {
				// let remaining = document.getElementById('remaining-' + item.itemId)
				this.$set(document.getElementById(dep.itemId + 'id' + dep.departmentId).style, 'border', 'none')
				dep.count = value
				this.$refs[`leftCount-${item.itemId}-${item.fromDepPriceUzs}-${item.termOfItem}`].$el.value = remain - value
				this.updateCountApi(item, dep, value)
			}
		},
		updateCountApi(item, dep, value) {
			let data = {
				requestDocumentId: this.$route.params.id,
				itemId: dep.itemId,
				count: value,
				termOfItem: item.termOfItem,
				priceUzs: item.fromDepPriceUzs,
				departmentId: dep.departmentId
			}
			WhDocument.updateRequestCount(data).then(res => {
				this.$vs.notify({
					title: 'Success updated',
					color: 'success',
					icon: 'close',
					position: 'top-right'
				})
			})
		},
		saveRequestDoc(action) {
			if (action === 'edit') {
				this.$bvModal.msgBoxConfirm(this.$t('actions.deletetitle'), {
					hideHeader: true,
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: this.$t('actions.yes'),
					cancelTitle: this.$t('actions.no'),
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(value => {
					if (value) {
						WhDocument.saveRequestDoc('CHECKING', this.$route.params.id).then(res => {
							this.$router.go(-1)
							this.$vs.notify({
								title: 'Success',
								color: 'success',
								icon: 'close',
								position: 'top-right'
							})
						})
					}
				})
			} else if (action === 'check') {
				this.$bvModal.msgBoxConfirm(this.$t('actions.deletetitle'), {
					hideHeader: true,
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: this.$t('actions.yes'),
					cancelTitle: this.$t('actions.no'),
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(value => {
					if (value) {
						WhDocument.saveEndRequestDoc(this.$route.params.id).then(res => {
							this.$router.go(-1)
							this.$vs.notify({
								title: 'Success',
								color: 'success',
								icon: 'close',
								position: 'top-right'
							})
						})
					}
				})
			}
		},
		toRecount() {
			WhDocument.saveRequestDoc('CHECKING', this.$route.params.id).then(res => {
				this.$router.go(-1)
				this.$vs.notify({
					title: 'Success',
					color: 'success',
					icon: 'close',
					position: 'top-right'
				})
			})
		},
		paginate(index, page_size, page_number) {
			--page_size;
			return (page_number * page_size) + index + 1;
		},
		remaining(item) {
			let allCount = 0,
				tmp = {}
			if (this.items.length > 0) {
				this.items.forEach(i => {
					item.toDeps.forEach(d => {
						if (i.itemId == item.itemId && i.termOfItem == item.termOfItem) {
							if (item.fromDepPriceUzs) {
								if (i.fromDepPriceUzs == item.fromDepPriceUzs) {
									tmp = i
									if (d.count) {
										allCount += parseFloat(d.count)
									}
								}
							} else {
								if (i.priceUzs == item.priceUzs) {
									tmp = i
									if (d.count) {
										allCount += parseFloat(d.count)
									}
								}
							}
						}
					})
				})
				return tmp.fromDep.remaining - allCount
			} else {
				return 0
			}
		},
		remainingToCheck(item) {
			let allCount = 0,
				tmp = {}
			if (this.items.length > 0) {
				this.items.forEach(i => {
					item.toDeps.forEach(d => {
						if (i.itemId == item.itemId && i.termOfItem == item.termOfItem) {
							if (item.fromDepPriceUzs) {
								if (i.fromDepPriceUzs == item.fromDepPriceUzs) {
									tmp = i
									if (d.sendCount) {
										allCount += parseFloat(d.sendCount)
									}
								}
							} else {
								if (i.priceUzs == item.priceUzs) {
									tmp = i
									if (d.sendCount) {
										allCount += parseFloat(d.sendCount)
									}
								}
							}
						}
					})
				})
				return tmp.fromDep.remaining - allCount
			} else {
				return 0
			}
		},
		remain(item, dep) {
			let allCount = 0,
				tmp = {}
			if (this.items.length > 0) {
				this.items.forEach(i => {
					item.toDeps.forEach(d => {
						if (i.itemId == item.itemId && i.termOfItem == item.termOfItem) {
							if (item.fromDepPriceUzs) {
								if (i.fromDepPriceUzs == item.fromDepPriceUzs) {
									tmp = i
									if (d.department_id !== dep.department_id) {
										if (d.count) {
											allCount += parseFloat(d.count)
										}
									}
								}
							} else {
								if (i.priceUzs == item.priceUzs) {
									tmp = i
									if (d.department_id !== dep.department_id) {
										if (d.count) {
											allCount += parseFloat(d.count)
										}
									}
								}
							}
						}
					})
				})
				return tmp.fromDep.remaining - allCount
			} else {
				return 0
			}
		}
	},
	created() {
		this.getList();
	}
}
</script>

<style scoped>
.width {
	width: 100%;
}
</style>
